module.exports = __webpack_public_path__ + "static/media/text-loading.fe02c656.svg";